import { createAction } from '@reduxjs/toolkit';


export const getClearResponse = createAction('CLEAR_RESULT', response => {
    return{
        payload: {
            response: response
        }
    }
});



export const getIacmLocationCall = createAction('GET_IACM_LOCATION', (codeToken) => {
    return{
        payload:{
            codeToken: codeToken,
        }
    }
});


export const getIacmLocationSuccess = createAction('GET_IACM_LOCATION_SUCCESS', response => {
    return{
        payload: {
            response: response
        }
    }
});

export const getIacmLocationFailure = createAction('GET_IACM_LOCATION_FAILURE', message => {
    return{
        payload: {
            message: message
        }
    }
});

export const getIacmActivateLocationCall = createAction('GET_IACM_ACTIVATE_LOCATION', (codeId) => {
    return{
        payload: {
            codeId: codeId,
        }
    }
});


export const getIacmActivateLocationSuccess = createAction('GET_IACM_ACTIVATE_LOCATION_SUCCESS', response => {
    return{
        payload: {
            response: response
        }
    }
});

export const getIacmActivateLocationFailure = createAction('GET_IACM_ACTIVATE_LOCATION_FAILURE', message => {
    return{
        payload: {
            message: message
        }
    }
});




export const toggleLeftPanel = createAction('TOGGLE_LEFTPANEL', response => {
    return{
        payload: {
            response: response
        }
    }
});


